import { getPhysicians } from '@mummssoftware/utils/pimReader';

export const formatDoctorInfo = (docs) =>
  Array.isArray(docs) &&
  docs.map((doctor) => ({
    label: `${doctor.lastName}, ${doctor.firstName}${
      doctor.credentials || doctor.primaryRole
        ? `, ${doctor.credentials || doctor.primaryRole}`
        : ''
    }${doctor.npi ? ` - ${doctor.npi}` : ''}`,
    firstName: doctor.firstName,
    lastName: doctor.lastName,
    credentials: doctor.credentials || '',
    personNumber: doctor.personNumber,
    value: doctor.personNumber,
    id: doctor.id,
  }));

export const getMedDoctors = async (pim, siteId, keycloak, patient, agency) => {
  let attendingAndHospicePhysicianList = [];
  let allDoctors = [];
  try {
    const pimDoctors = await pim.query(
      'pimpersonnamereplacement_vw',
      {
        select: `*`,
        filterrolegroupname: `eq.Doctor`,
        siteId: `eq.${siteId}`,
      },
      'pimreader',
    );
    attendingAndHospicePhysicianList = await getPhysicians(
      keycloak,
      agency,
      patient,
      'med',
    );

    allDoctors =
      pimDoctors && Array.isArray(pimDoctors)
        ? formatDoctorInfo(pimDoctors)
        : null;

    attendingAndHospicePhysicianList =
      attendingAndHospicePhysicianList &&
      Array.isArray(attendingAndHospicePhysicianList)
        ? formatDoctorInfo(attendingAndHospicePhysicianList)
        : null;
  } catch (e) {
    console.error(e);
  }
  return [attendingAndHospicePhysicianList, allDoctors];
};
